import type { ModelViewButtonProps } from "./model-view-button.type";
import type { ButtonProps } from "antd";

import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useModelNavigate, type ModelItem } from "@/modules/model";

const ModelViewButton = <Item extends ModelItem>({
  modelKey,
  item,
  onClick,
  ...buttonProps
}: ModelViewButtonProps<Item>) => {
  const { t } = useTranslation();
  const { navigateToItem } = useModelNavigate();

  const onViewClick: ButtonProps["onClick"] = (e) => {
    navigateToItem(modelKey, item);
    onClick?.(e);
  };

  return (
    <Button onClick={onViewClick} {...buttonProps}>
      {t("global:view")}
    </Button>
  );
};

export default ModelViewButton;
